/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { ApiSimpleTenantFromJSON, ApiSimpleTenantToJSON, ApiSimpleTenantResponseFromJSON, } from '../models';
/**
 *
 */
export class SamlServiceApi extends runtime.BaseAPI {
    /**
     */
    samlServiceCreateTenantRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling samlServiceCreateTenant.');
            }
            const queryParameters = {};
            if (requestParameters.tenantId !== undefined) {
                queryParameters['tenantId'] = requestParameters.tenantId;
            }
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/tenants`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ApiSimpleTenantToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleTenantFromJSON(jsonValue));
        });
    }
    /**
     */
    samlServiceCreateTenant(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.samlServiceCreateTenantRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    samlServiceDeleteTenantRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
                throw new runtime.RequiredError('tenantId', 'Required parameter requestParameters.tenantId was null or undefined when calling samlServiceDeleteTenant.');
            }
            const queryParameters = {};
            if (requestParameters.bodyId !== undefined) {
                queryParameters['body.id'] = requestParameters.bodyId;
            }
            if (requestParameters.bodyName !== undefined) {
                queryParameters['body.name'] = requestParameters.bodyName;
            }
            if (requestParameters.bodyEntityId !== undefined) {
                queryParameters['body.entityId'] = requestParameters.bodyEntityId;
            }
            if (requestParameters.bodyDomain !== undefined) {
                queryParameters['body.domain'] = requestParameters.bodyDomain;
            }
            if (requestParameters.bodyEnabled !== undefined) {
                queryParameters['body.enabled'] = requestParameters.bodyEnabled;
            }
            if (requestParameters.bodyProvider !== undefined) {
                queryParameters['body.provider'] = requestParameters.bodyProvider;
            }
            if (requestParameters.bodyMetaDataUrl !== undefined) {
                queryParameters['body.metaDataUrl'] = requestParameters.bodyMetaDataUrl;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/tenants/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     */
    samlServiceDeleteTenant(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.samlServiceDeleteTenantRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    samlServiceListTenantsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters.tenantId !== undefined) {
                queryParameters['tenantId'] = requestParameters.tenantId;
            }
            if (requestParameters.bodyId !== undefined) {
                queryParameters['body.id'] = requestParameters.bodyId;
            }
            if (requestParameters.bodyName !== undefined) {
                queryParameters['body.name'] = requestParameters.bodyName;
            }
            if (requestParameters.bodyEntityId !== undefined) {
                queryParameters['body.entityId'] = requestParameters.bodyEntityId;
            }
            if (requestParameters.bodyDomain !== undefined) {
                queryParameters['body.domain'] = requestParameters.bodyDomain;
            }
            if (requestParameters.bodyEnabled !== undefined) {
                queryParameters['body.enabled'] = requestParameters.bodyEnabled;
            }
            if (requestParameters.bodyProvider !== undefined) {
                queryParameters['body.provider'] = requestParameters.bodyProvider;
            }
            if (requestParameters.bodyMetaDataUrl !== undefined) {
                queryParameters['body.metaDataUrl'] = requestParameters.bodyMetaDataUrl;
            }
            const headerParameters = {};
            const response = yield this.request({
                path: `/services/tenants`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleTenantResponseFromJSON(jsonValue));
        });
    }
    /**
     */
    samlServiceListTenants(requestParameters = {}, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.samlServiceListTenantsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    samlServiceUpdateTenantRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.tenantId === null || requestParameters.tenantId === undefined) {
                throw new runtime.RequiredError('tenantId', 'Required parameter requestParameters.tenantId was null or undefined when calling samlServiceUpdateTenant.');
            }
            if (requestParameters.body === null || requestParameters.body === undefined) {
                throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling samlServiceUpdateTenant.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/services/tenants/{tenantId}`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters.tenantId))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: ApiSimpleTenantToJSON(requestParameters.body),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => ApiSimpleTenantFromJSON(jsonValue));
        });
    }
    /**
     */
    samlServiceUpdateTenant(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.samlServiceUpdateTenantRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
/**
    * @export
    * @enum {string}
    */
export var SamlServiceDeleteTenantBodyProviderEnum;
(function (SamlServiceDeleteTenantBodyProviderEnum) {
    SamlServiceDeleteTenantBodyProviderEnum["TENANT_PROVIDER_UNSPECIFIED"] = "TenantProviderUnspecified";
    SamlServiceDeleteTenantBodyProviderEnum["TENANT_PROVIDER_MICROSOFT"] = "TenantProviderMicrosoft";
})(SamlServiceDeleteTenantBodyProviderEnum || (SamlServiceDeleteTenantBodyProviderEnum = {}));
/**
    * @export
    * @enum {string}
    */
export var SamlServiceListTenantsBodyProviderEnum;
(function (SamlServiceListTenantsBodyProviderEnum) {
    SamlServiceListTenantsBodyProviderEnum["TENANT_PROVIDER_UNSPECIFIED"] = "TenantProviderUnspecified";
    SamlServiceListTenantsBodyProviderEnum["TENANT_PROVIDER_MICROSOFT"] = "TenantProviderMicrosoft";
})(SamlServiceListTenantsBodyProviderEnum || (SamlServiceListTenantsBodyProviderEnum = {}));
